import React from 'react';
import Feedback from 'entries/containers/feedback';

const FeedbackTile = (props) => (
  <div className={`column column-block feedback-tile offset-${props.item.horizontalOffset}`}>
    <Feedback {...props} />
  </div>
);

export default FeedbackTile;



// WEBPACK FOOTER //
// ./entries/components/feedback_tile.jsx